import React, { Component } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem } from 'reactstrap';
import './header.scss';
import { NavLink } from 'react-router-dom';


class Header extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.closeIfOpen = this.closeIfOpen.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  // Closes the mobile navbar if it is expanded when
  // changing pages
  closeIfOpen() {
    if (this.state.isOpen === true) {
      this.setState({
        isOpen: false
      });
    }
  }

  render() {
    // Fix for not reloading
    function HomeLink(props) {
      var pathName = window.location.pathname;
      if (pathName === '/') {
        return (
          <NavItem>
            <a href="/">Home</a>
          </NavItem>
        );
      }
      else {
        return (
          <NavItem>
            <NavLink to="/" onClick={props.closeIfOpen}>Home</NavLink>
          </NavItem>
        );
      }
    }

    return (
      <div>
        <Navbar className="bb-navbar navbar nav-header" fixed="top" light expand="md">
          <span>
            <NavbarBrand href="/"><img src={require("../../assets/bb-logo.png")} alt="Bit Benders" className="logo-img"/></NavbarBrand>
          </span>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <HomeLink closeIfOpen={this.closeIfOpen}/>
              <NavItem>
                <NavLink to="/tech" onClick={this.closeIfOpen}>Tech</NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/portfolio" onClick={this.closeIfOpen}>Portfolio</NavLink>
              </NavItem>
              {/*
              <NavItem>
                <NavLink to="/blog">Blog</NavLink>
              </NavItem>
              */}
              <NavItem>
                <NavLink to="/contact" onClick={this.closeIfOpen}>Contact</NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/header.js